<div class="fs-wrapper">
    <div class="legend">{{legend}}</div>

    <ng-container [ngTemplateOutlet]="template"></ng-container>
</div>